import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApprovalTypeSchemeService from "services/Setup/ApprovalTypeScheme/ApprovalTypeSchemeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  approvalTypeSchemeList: {},
};

export const getApprovalTypeScheme = createAsyncThunk(
  "approvalTypeScheme/getApprovalTypeScheme",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApprovalTypeSchemeService.getApprovalTypeSchemeService(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        // console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      //   console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postApprovalTypeScheme = createAsyncThunk(
  "approvalTypeScheme/postApprovalTypeScheme",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApprovalTypeSchemeService.postApprovalTypeSchemeService(
          userInput
        );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApprovalTypeSchemeService = createAsyncThunk(
  "approvalTypeScheme/putApprovalTypeSchemeService",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApprovalTypeSchemeService.putApprovalTypeSchemeServiceService(
          userInput
        );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const ApprovalTypeScheme = createSlice({
  name: "approvalTypeScheme",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get Prospect List
      .addCase(getApprovalTypeScheme.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApprovalTypeScheme.fulfilled, (state, action) => {
        state.loading = false;
        state.approvalTypeSchemeList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getApprovalTypeScheme.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   post
      .addCase(postApprovalTypeScheme.pending, (state) => {
        state.loading = true;
      })
      .addCase(postApprovalTypeScheme.fulfilled, (state, action) => {
        // console.log("actionpostGuarantor", action);
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(postApprovalTypeScheme.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   put
      .addCase(putApprovalTypeSchemeService.pending, (state) => {
        state.loading = true;
      })
      .addCase(putApprovalTypeSchemeService.fulfilled, (state, action) => {
        // console.log("actionpostGuarantor", action);
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(putApprovalTypeSchemeService.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  ApprovalTypeScheme.actions;

export default ApprovalTypeScheme.reducer;
